import axios from 'axios';

const apiPrefix = '/api/auth/event';

const trackAuthPopupOpen = async (data) => {
	await axios.post(`${apiPrefix}/track`, data);
};

const exportObj = {
	trackAuthPopupOpen
};

export default exportObj;
